<div class="d-flex flex-column">
  <qpoint-map [modes]="mapModes" [setZoomLevelOnFitBounds]="true" [enableFullscreenControl]="true" [showFitBoundsButton]="true"
    [showSelector]="showPlantSelector()" [selectorTemplate]="selectorTemplate" (mapModeChanged)="setActiveMode($event)" (mapClick)="handleMapClick()">
    <qpoint-map-marker *ngIf="sitePoi() as sitePoi" [options]="sitePoi"></qpoint-map-marker>
    <qpoint-map-marker *ngFor="let plantPoi of plantPois()" [options]="plantPoi"></qpoint-map-marker>

    <qpoint-map-marker *ngIf="routeDragMarker()" [options]="routeDragMarker()" [fitToBounds]="false"
      (mapDragend)="handleNewMarkerDragEnd($event)"
      (mapMarkerRightClick)="handleNewMarkerRightClick($event)"></qpoint-map-marker>

    <ng-container *ngFor="let transportRoute of transportRoutesForMap()">
      <qpoint-map-polyline [polyline]="transportRoute.routeToPlant"
        [options]="{ strokeColor: transportRoute.routeToPlantColor, editable: false }"
        (polylineMousemove)="onMouseMove($event, 'toPlant', transportRoute)" [manualMapModeActive]="true"
        (polylineMouseout)="onMouseOut('toPlant')"
        (resetPolylineClicked)="handlePolylineReset(transportRoute, 'toPlant')"></qpoint-map-polyline>
      <qpoint-map-polyline [polyline]="transportRoute.routeToSite"
        [options]="{ strokeColor:  transportRoute.routeToSiteColor, editable: false }"
        (polylineMousemove)="onMouseMove($event, 'toSite', transportRoute)" [manualMapModeActive]="true"
        (polylineMouseout)="onMouseOut('toSite')"
        (resetPolylineClicked)="handlePolylineReset(transportRoute, 'toSite')"></qpoint-map-polyline>
    </ng-container>

    <ng-container *ngIf="activeMode() !== null">
      <qpoint-map-marker
        *ngFor="let marker of asMarker(activeRouteToWaypoints()?.coordinates); index as i"
        [options]="marker" [fitToBounds]="false"
        (mapDragend)="handleMarkerChange($event, i)" (mapMarkerRightClick)="handleMarkerRightClick($event, i)"
        (mapDragStart)="resetMarkerMenu()"></qpoint-map-marker>
    </ng-container>
  </qpoint-map>

  <ng-template #selectorTemplate>
    <qpoint-map-plant-suggestlist
      [plantsWithRoutes]="plantsWithRoutes()"
      [selectedPlantId]="selectedPlantId"
      (plantChanged)="plantChanged($event)">
    </qpoint-map-plant-suggestlist>
  </ng-template>
</div>